
export enum DistractionState {
    Deactivated = 0,
    Starting,
    Active,
    Ending
}

export interface DistractionConfig{
    x: number,
    y: number,
    depth: number,
}

export default abstract class Distraction {
    private disabled : boolean = false;
    private state !: DistractionState;
    private pendingActivation: boolean = false;
    private pendingDeactivation: boolean = false;

    protected scene : Phaser.Scene;
    protected config : DistractionConfig;

    private activeCallback !: Function;
    private deactivatedCallback !: Function;

    constructor(scene: Phaser.Scene, config: DistractionConfig){
        this.scene = scene;
        this.config = config;
    }

    protected init(){
        this.changeState(DistractionState.Deactivated);
    }

    public setCallbacks(onActivated: Function, onDeactivated: Function){
        this.activeCallback = onActivated;
        this.deactivatedCallback = onDeactivated;
    }

    public activate(){ //start the distraction
        if (!this.canActivate()){
            this.pendingActivation = true;
        } else {
            this.pendingActivation = false;
            this.changeState(DistractionState.Starting);
        }
    }

    public deactivate(){ //distraction ended -> controlled by child classes
        if (this.state === DistractionState.Starting){
            this.pendingDeactivation = true;
            return;
        }

        if (!this.isActive()) return;

        this.changeState(DistractionState.Ending);
        this.pendingDeactivation = false;
    }

    protected changeState(newState: DistractionState){
        this.state = newState;
        this.handleStateChange(newState);
    }

    private handleStateChange(newState: DistractionState){
        if (this.disabled) return;
        
        switch(newState){
            case DistractionState.Deactivated:
                if (this.deactivatedCallback) this.deactivatedCallback();

                this.onDeactivated();

                //Instantly reactivate if needed
                if (this.pendingActivation){
                    this.activate();
                }

                break;
            case DistractionState.Starting:
                this.onStarting();
                break;
            case DistractionState.Active:
                if (this.activeCallback) this.activeCallback();
                this.onActivated();

                if (this.pendingDeactivation){
                    this.deactivate();
                }
                break;
            case DistractionState.Ending:
                this.onEnding();
                break;
            default:
                console.log("Unrecognized state: " + newState);
                break;
        }
    }

    abstract onDeactivated():void;
    abstract onStarting():void;
    abstract onActivated():void;
    abstract onEnding():void;

    abstract onGameLost():void;

    public isActive() : boolean {
        return this.state === DistractionState.Active;
    }

    public canActivate() : boolean {
        return this.state === DistractionState.Deactivated;
    }

    public isPendingActivation() : boolean {
        return this.pendingActivation;
    }

    public forceDisable(){
        this.disabled = true;
        this.onEnding();
    }
}